import { User } from './types/User';
import { MakeCall } from './createMakeCall';

const googleLogin = (makeCall: MakeCall) => (code: string) =>
  makeCall<User>('POST', `/api/v2/action/google-onetap-login`, {
    data: { code },
  });

export { googleLogin };
